import { useTranslation } from 'react-i18next';

export default function AboutHero() {
  const { t } = useTranslation();

  const stats = [
    { val: t('about_hero_stat1_val'), label: t('about_hero_stat1_label') },
    { val: t('about_hero_stat2_val'), label: t('about_hero_stat2_label') },
    { val: t('about_hero_stat3_val'), label: t('about_hero_stat3_label') },
    { val: t('about_hero_stat4_val'), label: t('about_hero_stat4_label') },
  ];

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/29d3395578c669e26caba57a054557e1.jpg"
          alt="ORPM Investment LLC team"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F2A50]/92 via-[#0F2A50]/75 to-[#0F2A50]/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-28 pb-20 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-sky-500/20 border border-sky-400/40 rounded-full px-4 py-1.5 mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-sky-400"></div>
            <span className="text-sky-300 text-xs font-semibold tracking-widest uppercase">
              {t('about_hero_badge')}
            </span>
          </div>

          {/* Title */}
          <h1 className="text-white font-bold leading-tight mb-6">
            <span className="block text-4xl md:text-5xl lg:text-6xl">{t('about_hero_title1')}</span>
            <span className="block text-4xl md:text-5xl lg:text-6xl text-sky-400">{t('about_hero_title2')}</span>
          </h1>

          {/* Description */}
          <p className="text-white/80 text-lg leading-relaxed mb-10 max-w-xl">
            {t('about_hero_desc')}
          </p>

          {/* CTA row */}
          <div className="flex items-center gap-3 flex-wrap">
            <a
              href="tel:+15615122820"
              className="inline-flex items-center gap-2.5 bg-sky-600 hover:bg-sky-500 text-white font-semibold px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </div>
              +1 (561) 512-2820
            </a>
            <a
              href="mailto:info@orpminvestment.com"
              className="inline-flex items-center gap-2.5 border border-white/30 hover:border-white/60 text-white font-semibold px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-base"></i>
              </div>
              info@orpminvestment.com
            </a>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="bg-white/5 backdrop-blur-sm px-8 py-6 flex flex-col items-center text-center"
            >
              <span className="text-3xl md:text-4xl font-bold text-sky-400 mb-1">{stat.val}</span>
              <span className="text-white/70 text-xs font-medium tracking-wide">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
